/**
 * 按 id 取房源（用于下拉框回显名称）：
 * - 模块级缓存：同一个 id 只查一次
 * - 同一时刻的多个 id 合并成一次请求（多个下拉框同时渲染也只发一次）
 * - 查询不带任何状态筛选，所以已租出、已失效的房源也能查到
 */
export function createHostLookup(searchFn) {
  const cache = new Map(); // id -> host
  const inflight = new Map(); // id -> Promise
  let batch = [];
  let timer = null;

  const flush = async () => {
    const waiting = batch;
    batch = [];
    timer = null;
    const ids = [...new Set(waiting.map((w) => w.id))];
    try {
      const { data } = await searchFn({ ids: ids.join(","), limit: ids.length });
      (Array.isArray(data) ? data : []).forEach((h) => cache.set(h._id, h));
      waiting.forEach((w) => w.resolve(cache.get(w.id) || null)); // 查不到(房源已被删除)返回 null，不缓存
    } catch {
      waiting.forEach((w) => w.resolve(null)); // 请求失败不缓存，下次还会重试
    } finally {
      ids.forEach((id) => inflight.delete(id));
    }
  };

  return {
    peek: (id) => cache.get(id),
    remember: (hosts) => hosts.forEach((h) => cache.set(h._id, h)), // 搜索结果顺手写进缓存
    get(id) {
      if (cache.has(id)) return Promise.resolve(cache.get(id));
      if (inflight.has(id)) return inflight.get(id);
      const p = new Promise((resolve) => {
        batch.push({ id, resolve });
        if (!timer) timer = setTimeout(flush, 0);
      });
      inflight.set(id, p);
      return p;
    },
  };
}
